// Diwali 2026: Lakshmi Puja is observed on 8 November in India.
// Keep the visual treatment around the main day so the campaign has room to breathe.
const WINDOW_START = new Date(2026, 10, 1, 0, 0, 0);
const WINDOW_END = new Date(2026, 10, 15, 23, 59, 59);
const DIWALI_DAY = new Date(2026, 10, 8);

export function isDiwaliSeason(now = new Date()) {
  return now >= WINDOW_START && now <= WINDOW_END;
}

export function getDiwaliCopy(now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const daysUntil = Math.round((DIWALI_DAY - today) / 86400000);

  if (daysUntil === 0) {
    return { eyebrow: "Diwali season", line: "A little more light. A lot more room to celebrate." };
  }
  if (daysUntil > 0) {
    return { eyebrow: "Diwali season", line: "Make room for the people who make it feel like home." };
  }
  return { eyebrow: "Diwali season", line: "Keep the celebration going. Stay a little longer." };
}
